import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';

import { Header } from '@expo/html-elements';

import { Container, theme, useContainerSpacing, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardsHeaderContainer = (props: PropsWithChildren) => {
  const { children } = props;

  const { match } = useResponsive();
  const containerSpacing = useContainerSpacing();
  const { right: safeAreaRightInset, left: safeAreaLeftInset } = useSafeAreaInsets();

  // ─── Styles ────────────────────────────────────────────────────────────────

  const headerContainerDynamicStyles = useStyle(
    () => ({
      paddingRight: Math.max(safeAreaRightInset, containerSpacing),
      paddingLeft: Math.max(safeAreaLeftInset, containerSpacing),
    }),
    [containerSpacing, safeAreaLeftInset, safeAreaRightInset],
  );
  const headerContainerStyles = [
    match([styles.headerContainerXS, styles.headerContainerSM]),
    headerContainerDynamicStyles,
  ];

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <Header>
      <Container style={headerContainerStyles}>{children}</Container>
    </Header>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  headerContainerXS: {
    paddingTop: theme.spacing['6'],
    paddingBottom: theme.spacing['4'],
    rowGap: theme.spacing['4'],
  },
  headerContainerSM: {
    paddingTop: theme.spacing['16'],
    paddingBottom: theme.spacing['10'],
    rowGap: theme.spacing['6'],
  },
});
